<template>
  <head>
    <title>{{ $t("blogs") }}</title>
    <meta
      name="description"
      :content="
        $i18n.locale === 'ar' ? 'تصفح اخر الأخبار' : 'Check out our latest news'
      "
    />
  </head>
  <div class="news-vue">
    <NavbarComponent />
    <!-- ======= Breadcrumbs ======= -->
    <div
      class="breadcrumbs d-flex align-items-center"
      style="background-image: url('assets/img/ourservice.jpg')"
      id="news"
    >
      <div
        class="container position-relative d-flex flex-column align-items-center"
      >
        <h2>{{ $t("blogs") }}</h2>
        <ol>
          <li>
            <a href="/">{{ $t("home") }}</a>
          </li>
          <li>{{ $t("blogs") }}</li>
        </ol>
      </div>
    </div>
    <!-- End Breadcrumbs -->
    <!-- ======= Blog Section ======= -->
    <section class="blog">
      <div class="container my-5" data-aos="fade-up">
        <div class="row g-5">
          <div class="col-lg-12" data-aos="fade-up" data-aos-delay="200">
            <div class="row gy-5 posts-list" v-if="data.length != 0">
              <div class="col-lg-4" v-for="(item, index) in data" :key="index">
                <article class="d-flex flex-column">
                  <div class="post-img">
                    <img
                      :src="
                        $store.state.server +
                        ($i18n.locale == 'ar' ? item.img : item.img_en)
                      "
                      alt=""
                      class="img-fluid"
                    />
                  </div>

                  <h2 class="title-blog mb-4">
                    <a href="/" style="cursor: none; pointer-events: none">{{
                      $i18n.locale == "ar" ? item.name_ar : item.name_en
                    }}</a>
                  </h2>

                  <div class="read-more mt-auto align-self-end">
                    <a :href="'/news-details?id=' + item.id"
                      >{{
                        $i18n.locale == "ar" ? "قراءة المزيد" : "Read more"
                      }}
                      <i
                        :class="
                          $i18n.locale == 'ar'
                            ? 'bi bi-arrow-left'
                            : 'bi bi-arrow-right'
                        "
                      ></i
                    ></a>
                  </div>
                </article>
              </div>
              <!-- End post list item -->
            </div>
            <h2 class="my-5" v-else>
              {{
                $i18n.locale == "ar"
                  ? "لا يوجد أخبار حتى الآن"
                  : "No news till now"
              }}
            </h2>
            <!-- End blog posts list -->
          </div>
        </div>
      </div>
    </section>
    <!-- End Blog Section -->
  </div>
</template>

<script>
import NavbarComponent from "@/components/NavbarComponent.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "news-vue",
  components: {
    NavbarComponent,
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_blogs")
        .then((response) => {
          this.data = response.data;
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.blog .posts-list .title-blog {
  font-size: 20px;
  font-weight: 600;
  padding: 0;
  margin: 20px 0 0 0;
}

.blog .posts-list .title-blog a {
  color: var(--color-secondary);
  transition: 0.3s;
}

.blog .posts-list .title-blog a:hover {
  color: var(--color-primary);
}
</style>
